module.exports = __webpack_public_path__ + "50f6d52c4695228170b9bb9a7e3aff09.svg";